<p-popover #popover [style]="style()">
  <ng-content></ng-content>
</p-popover>
